const homepage = require("./pages/homepage");
const news = require('./pages/news');
const faqpage = require('./pages/faq');
const documents = require('./pages/documents');
const documentDetail = require('./pages/documentDetail');
$("document").ready(function () {
    homepage();
    news();
    faqpage();
    documents();
    documentDetail();
    $('#toggle-menu').click(function () {
        $('#menu-content').animate({
            height: '100vh',
            maxHeight: '100vh',
            opacity: '1',
        });

        $(this).toggle();

        $('#close-menu').css({
            display: 'block'
        });
    });

    $('#close-menu').click(function () {
        $(this).toggle();

        $('#menu-content').animate({
            height: '0',
            maxHeight: '0',
            opacity: '0',
        });


        $('#toggle-menu').css({
            display: 'block'
        });
    });
})

$(window).resize(function () {

})
